import React from 'react'
import Logo from '../Img/logo.png'
import API from '../Utils/api'
import { handleLogout } from '../Utils/auth'
import { Link } from 'react-router-dom'
import MasterTemplate from "./MasterTemplate";


const getUsuarioLocal = () => {
    const usuarioStorage = window.localStorage.getItem('user')
    const usuario = JSON.parse(usuarioStorage)
    return usuario
}

export class GerenciarAdmins extends React.Component {
    constructor(props) {
        window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
        super(props)
        this.state = {
            user: window.localStorage.getItem('user'),
            admins: [],
            filteredList: []
        }
    }

    componentDidMount() {
        try {
            this.listarAdmins()
        } catch (e) {
            console.error(`Error: ${e}`)
        }
    }

    handleResetSenha = async (id) => {
        try {
            const response = await API.get(`/api/usuarios/${id}/nova-senha`)
            const { data } = response

            if (data.error) throw new Error(data.error)

            const { novaSenha, email } = data
            alert(`Anote a nova senha: ${novaSenha}, email: ${email}`)
        } catch (e) {
            console.error(e.message)
        }
    }

    async handleChangeStatus(_usuario) {
        try {
            var res = await API.post('/api/usuarios/update-one-user', { _id: _usuario._id, status: !_usuario.status })
            if (res) {
                window.location.reload();
            }
        } catch (err) {
            console.log(err)
        }
    }

    getUser = e => {
        try {
            const user = getUsuarioLocal()
            this.setState({ user })
        } catch (err) {
            console.log(err)
        }
    }

    listarAdmins = async e => {
        const usuario = getUsuarioLocal()
        try {
            const response = await API.post('/api/usuarios/listar-todos-admins')

            this.setState({ ...this.state, admins: response.data.sort(this.compararNome) })
            this.setState({ filteredList: this.state.admins });
        } catch (err) {
            console.log(err)
        }
    }

    compararNome(a, b) {
        if (a.nome.toLowerCase() > b.nome.toLowerCase()) {
            return 1;
        }
        if (a.nome.toLowerCase() < b.nome.toLowerCase()) {
            return -1;
        }

        return 0
    }

    searchName(e) {
        var filteredList = this.state.admins.filter(usuario => {
            if (usuario != undefined && usuario.nome.toLowerCase().includes(e.target.value.toLowerCase())) {
                return usuario;
            }
        }
        )

        this.setState({ filteredList: filteredList })
    }

    render() {
        return (
            <MasterTemplate label="Admins">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card strpied-tabled-with-hover">
                                <div className="card-header ">
                                    <Link
                                        to="/cadastro-admin"
                                        className="btn btn-fill btn-success float-md-right float-lg-right"
                                    >
                                        Cadastrar
                                    </Link>
                                    <h4 className="card-title">Acompanhe seus administradores</h4>
                                    <p className="card-category">Informações dos administradores</p>
                                    <span className="text-dark font-weight-bold">Total de administradores:</span> <span className="text-danger font-weight-bold"> {this.state.admins.length}</span>
                                </div>
                                <div className="card-body table-full-width table-responsive">
                                    <div className="row pl-5 pr-5 justify-content-center">
                                        <input className="form-control w-50" placeholder="busca rapida..." onChange={this.searchName.bind(this)}></input>
                                    </div>

                                    <table className="table table-hover table-striped table-sm">
                                        <thead>
                                            <tr>
                                                <th scope="col">Nome</th>
                                                <th scope="col">Telefone</th>
                                                <th scope="col">Email</th>
                                                <th scope="col">Status</th>
                                                <th scope="col" className="w-100"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.filteredList && this.state.filteredList.map((item, index) => {
                                                return (
                                                    <tr scope="row" key={index}>
                                                        <td>
                                                            {item.nome}
                                                        </td>
                                                        <td>
                                                            {item.telefone}
                                                        </td>
                                                        <td>
                                                            {item.email}
                                                        </td>
                                                        <td>
                                                            {item.status ? 'Ativo' : 'Bloqueado'}
                                                        </td>
                                                        <td className="w-100 d-flex justify-content-center">
                                                            <div className="dropdown">
                                                                <Link to="#" id={`dLabel_${index}`}
                                                                    type="button" data-toggle="dropdown"
                                                                    aria-haspopup="true"
                                                                    aria-expanded="false">
                                                                    <i className="fas fa-ellipsis-h"></i>
                                                                </Link>
                                                                <div className="dropdown-menu"
                                                                    aria-labelledby={`dLabel_${index}`}>
                                                                    <Link className="dropdown-item"
                                                                        to={`/cadastro-admin?id=${item._id}`}>Editar</Link>
                                                                    <Link to="#" className="dropdown-item"
                                                                        onClick={() => this.handleResetSenha(item._id)}>Redefinir
                                                                        senha</Link>
                                                                    <button className="dropdown-item"
                                                                        onClick={() => this.handleChangeStatus(item)}>{item.status ? 'Bloquear' : 'Ativar'}</button>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </MasterTemplate>
        )
    }
}

export default GerenciarAdmins
